import { useChartStore } from '@/store/chartStore';
import { WatchlistIcon, LayoutIcon, BellIcon, BotIcon, ScreenerIcon, FinancialsIcon } from '@/components/icons';

interface Props {
  onOpenScreener: () => void;
  onOpenFullFinancials: () => void;
}

export function RightToolbar({ onOpenScreener, onOpenFullFinancials }: Props) {
  const rightPanelActive    = useChartStore((s) => s.rightPanelActive);
  const setRightPanelActive = useChartStore((s) => s.setRightPanelActive);

  function togglePanel(panel: 'watchlist' | 'templates' | 'ai' | 'alerts') {
    setRightPanelActive(rightPanelActive === panel ? null : panel);
  }

  return (
    <aside className="relative flex flex-col items-center w-12 shrink-0 py-2 pr-[5px] glass" style={{ borderRadius: 0, borderTop: 'none', borderBottom: 'none', borderRight: 'none' }}>
      <button
        onClick={() => togglePanel('watchlist')}
        title="Watchlist"
        className={`flex items-center justify-center w-9 h-10 rounded transition-colors mb-1 ${
          rightPanelActive === 'watchlist'
            ? 'text-accent bg-accent/15 ring-1 ring-accent/30'
            : 'text-muted hover:text-text hover:bg-white/[0.06]'
        }`}
      >
        <WatchlistIcon size={24} />
      </button>
      <button
        onClick={() => togglePanel('templates')}
        title="Indicator templates"
        className={`flex items-center justify-center w-9 h-10 rounded transition-colors mb-1 ${
          rightPanelActive === 'templates'
            ? 'text-accent bg-accent/15 ring-1 ring-accent/30'
            : 'text-muted hover:text-text hover:bg-white/[0.06]'
        }`}
      >
        <LayoutIcon size={24} />
      </button>

      {/* Divider */}
      <div className="w-8 h-px bg-border/50 my-1 shrink-0" />

      {/* Alerts */}
      <button
        onClick={() => togglePanel('alerts')}
        title="Alerts"
        className={`flex items-center justify-center w-9 h-10 rounded transition-colors mb-1 ${
          rightPanelActive === 'alerts'
            ? 'text-accent bg-accent/15 ring-1 ring-accent/30'
            : 'text-muted hover:text-text hover:bg-white/[0.06]'
        }`}
      >
        <BellIcon size={24} />
      </button>

      {/* AI Chat — SerenAI */}
      <button
        onClick={() => togglePanel('ai')}
        title="SerenAI"
        className={`flex items-center justify-center w-9 h-10 rounded transition-colors mb-1 ${
          rightPanelActive === 'ai'
            ? 'text-accent bg-accent/15 ring-1 ring-accent/30'
            : 'text-muted hover:text-text hover:bg-white/[0.06]'
        }`}
      >
        <BotIcon size={24} />
      </button>

      {/* Screener */}
      <button
        onClick={onOpenScreener}
        title="Screener"
        className="flex items-center justify-center w-9 h-10 rounded transition-colors mb-1 text-muted hover:text-text hover:bg-white/[0.06]"
      >
        <ScreenerIcon size={22} />
      </button>

      {/* Full Financials */}
      <button
        onClick={onOpenFullFinancials}
        title="Full Financials"
        className="flex items-center justify-center w-9 h-10 rounded transition-colors mb-1 text-muted hover:text-text hover:bg-white/[0.06]"
      >
        <FinancialsIcon size={22} />
      </button>

    </aside>
  );
}
